function calculateReadingTime() {
    const text = $('.Single__content').text();
    const wpm = 225;
    const words = text.trim().split(/\s+/).length;
    const time = Math.ceil(words / wpm);

    $('.article-read-time').html('Lästid: ' + time + ' min');
}

export default function() {

    if ($('.Single__content').length === 0 || $('.article-read-time').length === 0)
        return;

    calculateReadingTime();
}


// WEBPACK FOOTER //
// ./scripts/components/reading-time.js